import { Modal, Spinner } from "react-bootstrap";
import CloseBtn from "assets/icons/Close-1.svg";
import "./OnDemandVideo.scss";

function CloseVideoCallConfirmationModal({show, setShowEndSessionModal, loadingEndSession, endCall}) {
  return (
      <Modal className="end-session-modal" size="lg" show={show} onHide={() => {setShowEndSessionModal(false)}} backdrop="static" keyboard={false} centered>
      <Modal.Header className="p-0">
        <button
          type="button"
          className="close close-button position-relative pb-0"
          onClick={() => {
            setShowEndSessionModal(false);
          }}
        >
          <img src={CloseBtn} alt="modal-close" className="w-30" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div className="title">Confirm End Call?</div>
          <div className="description">
            You can easily rejoin the call within the session duration.
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="flex-row button-footer">
        <button
          className={"btn btn-link cancel-button"}
          type="submit"
          onClick={() => setShowEndSessionModal(false)}
        >
          Cancel
        </button>
        <button
          className="btn btn-link end-button"
          type="submit"
          onClick={() => {
            endCall();
          }}
        >
          {loadingEndSession ? (
            <div className="loader">
              <Spinner animation="border" className="spinner" />
            </div>
          ) : (
            <>End Call</>
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default CloseVideoCallConfirmationModal;
